module.exports = __webpack_public_path__ + "img/icon_shop_03.1c5960c5.png";